import React$1 from 'react';

const Fullscreen = () => /*#__PURE__*/React$1.createElement("svg", {
  width: "39",
  height: "38",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M39.001 26.108v11.9h-11.9v-2l8.492-.002-7.421-7.42 1.414-1.414L37 34.585 37 26.108h2zM2 26.108v8.477l7.415-7.413 1.414 1.414-7.42 7.42 8.49.002v2H0v-11.9h2zM37.586 0l.01.011h1.405v11.9h-2L37 3.414l-7.414 7.414-1.414-1.414 7.402-7.402h-8.472v-2L37.575.01l.01-.011zM1.414 0l.011.011H11.9v2l-8.473.001 7.402 7.402-1.414 1.414L2 3.414v8.497H0V.011h1.404L1.414 0z",
  fillRule: "nonzero"
}));

export default Fullscreen;
